import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'shared/api/rtk-query';

export const cityApi = createApi({
  reducerPath: 'city-api',
  baseQuery: createBaseQuery(),
  endpoints: () => ({}),
});
